import React,{useEffect} from 'react';
import './Homepage.css';
import TopAutoSlide from './TopAutoSlide';
import HomepageSecondSection from './HomepageSecondSection';
import HomepageThirdSection from './HomepageThirdSection';
import HomepageFourthSection from './HomepageFourthSection';
import HomepageFifthSection from './HomepageFifthSection';
import VisionAndMission from './VisionAndMission';
import DirectorSection from './DirectorSection';
import BranchesSection from './BranchesSection';
import Certifications from './Certifications';
import SCADAArch from './SCADAArch';

const Homepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
<>
<div className="homepage">

 <TopAutoSlide/>
 <HomepageSecondSection/>
 <BranchesSection/>
 <Certifications/>
 <SCADAArch/>
 <DirectorSection/>
 <HomepageThirdSection/>
 <HomepageFourthSection/>
 <VisionAndMission/>
 <HomepageFifthSection/>
</div>
</>
  )
}

export default Homepage
